import React from "react";
import { FaLinkedinIn, FaGithub, FaLink } from "react-icons/fa";

const Media = () => {
  return (
    <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">

      {/* Social Links */}
      <div>
        <h2 className="text-base uppercase font-titleFont mb-4">
          Find me in
        </h2>

        <div className="flex gap-4">

          {/* LinkedIn */}
          <a
            href="https://www.linkedin.com/in/srsam"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn />
          </a>

          {/* GitHub */}
          <a
            href="https://github.com/ShamimRahmanSam"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>

          {/* Linktree */}
          <a
            href="https://linktr.ee/ShamimRahmanSam"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
            aria-label="Linktree"
          >
            <FaLink />
          </a>

        </div>
      </div>

      {/* Core Focus */}
      <div>
        <h2 className="text-base uppercase font-titleFont mb-4">
          Core Focus
        </h2>

        <div className="flex gap-4">

          <span className="bannerIcon" title="Software Engineering">
            <span className="text-sm font-bold">DEV</span>
          </span>

          <span className="bannerIcon" title="AI & Data">
            <span className="text-sm font-bold">AI</span>
          </span>

          <span className="bannerIcon" title="Film & Media">
            <span className="text-sm font-bold">FILM</span>
          </span>

        </div>
      </div>

    </div>
  );
};

export default Media;